import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 101;
  inset: 0;
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: #1E1E1E72;
  z-index: 100;
  inset: 0;
`;
